import { render } from "./ModalJustificativa.vue?vue&type=template&id=b9b9d13c&scoped=true"
import script from "./ModalJustificativa.vue?vue&type=script&lang=js"
export * from "./ModalJustificativa.vue?vue&type=script&lang=js"

import "./ModalJustificativa.vue?vue&type=style&index=0&id=b9b9d13c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b9d13c"]])

export default __exports__